import {Component} from "react";
import axios from "axios";

class VersionChecker extends Component {
    state = {
        version: localStorage.getItem("appVersion") || "0",
    };

    componentDidMount() {
        this.checkVersion();
        // this.interval = setInterval(this.checkVersion, 1 * 30 * 1000); // Check every 30 seconds
        this.interval = setInterval(this.checkVersion, 2 * 60 * 1000); // Check every 2 minutes
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    checkVersion = async () => {
        try {
            const response = await axios.get("/config.json", {cache: "no-store"});
            const newVersion = response.data.vers;

            if (newVersion && newVersion !== localStorage.getItem("appVersion")) {
                localStorage.setItem("appVersion", newVersion);
                window.location.reload(true);
            } else {
                console.log("V Matched");
            }
        } catch (error) {
            console.error("Error checking app version:", error);
        }
    };

    render() {
        return null; // This component doesn't render anything
    }
}

export default VersionChecker;
